import JsxHelper from '../Helpers/JsxHelper';
import LongText from '../Elements/LongText';
import React from 'react';

export default class ClientInvoiceEvaluatorPaymentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsEvname = '';
      this.AsSassieAsgnId = '';
      this.ClientName = '';
      this.ProjectName = '';
      this.ProjectId = '';
      this.IeType = '';
      this.IeStatus = '';
      this.PaidOutsideOfSystem = '';
      this.IeFee = '';
      this.IeFeeAdjustment = '';
      this.IeExpense = '';
      this.IeVat = '';
      this.IeEvaluatorCompletedDate = '';
      this.IeCreatedOn = '';
      this.CuName = '';
      this.CuCountry = '';
      this.IeRcyname = '';
      this.IeRcysymbol = '';
      return;
    }
    this.AsEvname = item.asEvname;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    this.ClientName = item.clientName;
    this.ProjectName = item.projectName;
    this.ProjectId = item.projectId;
    this.IeType = item.ieType;
    this.IeStatus = item.ieStatus;
    // CD-5421: from the related Assignment - explains a Closed status.
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.IeFee = item.ieFee;
    this.IeFeeAdjustment = item.ieFeeAdjustment;
    this.IeExpense = item.ieExpense;
    this.IeVat = item.ieVat;
    this.IeEvaluatorCompletedDate = item.ieEvaluatorCompletedDate;
    this.IeCreatedOn = item.ieCreatedOn;
    this.CuName = item.cuName;
    this.CuCountry = item.cuCountry;
    this.IeRcyname = item.ieRcyname;
    this.IeRcysymbol = item.ieRcysymbol;
  }

  static MoneyFields = ['IeFee', 'IeFeeAdjustment', 'IeExpense', 'IeVat'];
  static BoolFields = [];
  static DateFields = ['IeEvaluatorCompletedDate', 'IeCreatedOn'];

  static Currency() {
    return 'IeRcyname';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname', minWidth: 40 },
      { label: 'Apollo ID', orderById: 'AsSassieAsgnId', data: 'AsSassieAsgnId', minWidth: 20 },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: ClientInvoiceEvaluatorPaymentItem.getClientCellContent,
        minWidth: 40,
      },
      { label: 'Project', orderById: 'ProjectName', data: 'ProjectName', minWidth: 40 },
      { label: 'Project ID', orderById: 'ProjectId', data: 'ProjectId', minWidth: 20 },
      { label: 'Type', orderById: 'IeType', data: 'IeType', minWidth: 30 },
      { label: 'Status', orderById: 'IeStatus', data: 'IeStatus', minWidth: 20 },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Fee', orderById: 'IeFee', data: 'IeFee', minWidth: 20 },
      { label: 'Fee Addit.', orderById: 'IeFeeAdjustment', data: 'IeFeeAdjustment', minWidth: 20 },
      { label: 'Expense', orderById: 'IeExpense', data: 'IeExpense', minWidth: 20 },
      { label: 'Tax', orderById: 'IeVat', data: 'IeVat', minWidth: 20 },
      { label: 'Completed On', orderById: 'IeEvaluatorCompletedDate', data: 'IeEvaluatorCompletedDate', minWidth: 40 },
      { label: 'Created On', orderById: 'IeCreatedOn', data: 'IeCreatedOn', minWidth: 40 },
      {
        label: 'Location',
        orderById: 'CuName',
        data: ClientInvoiceEvaluatorPaymentItem.getLocationCellContent,
        minWidth: 40,
      },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 10 },
    ];
  }

  static getClientCellContent(item) {
    return (
      <LongText
        text={item.ClientName ? item.ClientName : ' '}
        maxLength={30}
      />
    );
  }

  static getLocationCellContent(item) {
    return (
      <LongText
        text={item.CuName ? item.CuName : ' '}
        maxLength={30}
      />
    );
  }
}
